<template>
	<div
		class="bet-recommendations"
		v-if="recommendations.length !== 0"
		@click="smoothScrollToBottom"
	>
		<div class="bet-recommendations__header">
			<p>{{ $t("betslip.related-bets") }}</p>
		</div>
		<carousel
			:paginationEnabled="true"
			:navigationEnabled="false"
			:perPageCustom="[
				[0, 1],
				[600, 2],
				[1000, 1],
			]"
			:paginationActiveColor="'var(--green)'"
			:paginationColor="'var(--gray)'"
			:paginationPadding="5"
			:paginationSize="5"
			@page-change="handlePageChange"
			:navigateTo="slideBack"
		>
			<slide
				v-for="(recommendation, idx) in recommendations.slice(0, 5)"
				:key="idx"
				:data-index="idx"
				:title="
					$options.filters.toTitleCase(recommendation.home_team) +
					' vs ' +
					$options.filters.toTitleCase(recommendation.away_team)
				"
				@slideclick="handleSlideClick"
			>
				<div
					class="slider-recommendation__item"
					v-if="!isLoadingStatus || !isLoadingStatus"
				>
					<div class="slider-recommendation__item__market">
						<div class="slider-recommendation__item__market__container">
							<!-- match -->
							<div class="slider-recommendation__item__market__match">
								<div class="slider-recommendation__item__market__match__name">
									<div>
										{{ recommendation.home_team | toTitleCase }}
									</div>
									<div>
										{{ recommendation.away_team | toTitleCase }}
									</div>
								</div>
							</div>

							<div class="slider-recommendation__item__market__odds">
								<!-- time -->
								<div class="slider-recommendation__item__market__time">
									<!-- {{ recommendation.start_time | timeFormat("dd/MM[,] HH:mm") }} -->
									{{
										$options.filters.humanTime(recommendation.start_time, 179)
									}}
								</div>
								<!-- odds -->
								<div
									class="slider-recommendation__item__market__odds__column"
									v-for="(match, idx) in recommendation.markets"
									:key="idx"
								>
									<div
										v-if="match.odds"
										class="slider-recommendation__item__market__odds__recodds prebet-match__odds"
										:number-of-odds="match.odds.length"
									>
										<match-odd
											v-for="(odd, index) in match.odds"
											:key="index"
											:odd="mapOdd(odd, recommendation)"
											:match="recommendation"
											:market="match"
											@added="handleAddRecommendation"
											@removed="handleRemoveRecommendation"
										/>
									</div>
								</div>
								<!-- more markets -->
								<div class="slider-recommendation__item__market__odds__column">
									<div class="slider-recommendation__item__market__odds--more">
										<router-link
											:to="{
												name: 'prebet-markets',
												params: {
													parentMatchId: recommendation.parent_match_id,
												},
											}"
											title="More markets link, opens a new window"
											@click.native="
												$tracking.recommendations.open({
													id: recommendation.parent_match_id,
												})
											"
											>{{
												$t("betslip.related-bets-starts-more-markets")
											}}</router-link
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<RecommendationsLoader v-else />
			</slide>
			<!-- <slide>See more</slide> -->
		</carousel>
	</div>
</template>
<script>
import MatchOdd from "../Prebets/MatchOdd.vue";
import Empty from "../Shared/Empty.vue";
import RecommendationsLoader from "../Shared/RecommendationsLoader.vue";
import _ from "lodash";
export default {
	name: "RecommendationSlider",
	props: {
		bets: {
			type: Array,
			required: [],
		},
	},
	data() {
		return {
			canShowBottomSheet: false,
			dontFetchRecommendations: false,
			initialLoadState: false,
			slideCount: 0,
		};
	},
	watch: {
		bets(n, o) {
			let vm = this;
			if (vm.dontFetchRecommendations) {
				vm.dontFetchRecommendations = false;
				return;
			}
			if (n.length > 0) {
				vm.fetchRecommendations();
			}
			if (n.length === 0)
				vm.$store.dispatch("recommendations/getRecommendations", []);
		},
		initialLoadState(v) {
			let vm = this;
			if (!v) {
				vm.smoothScrollToBottom();
			}
		},
		slideCount(v) {
			this.slideCount = v;
		},
	},
	components: {
		MatchOdd,
		Empty,
		RecommendationsLoader,
	},
	mounted() {
		let vm = this;
		vm.fetchRecommendations();

		if (vm.isLoadingStatus) {
			vm.smoothScrollToBottom();
		}
	},
	computed: {
		recommendations() {
			let vm = this;
			const recommendations = vm.$store.getters["recommendations/list"].filter(
				(recommendation) => {
					return recommendation.markets !== null;
				}
			);
			if (recommendations.length === 0) {
				vm.initialLoadState = true;
			} else {
				vm.initialLoadState = false;
			}
			return recommendations;
		},
		isLoadingStatus() {
			return this.$store.getters["recommendations/isLoading"];
		},
		slideBack() {
			let vm = this;
			if (vm.slideCount > 0 && vm.isLoadingStatus) {
				return vm.slideCount;
			}
			vm.smoothScrollToBottom();
			return 0;
		},
	},
	methods: {
		handleSlideClick(dataset) {
			this.slideCount = parseInt(dataset.index);
		},
		handlePageChange(idx) {
			const rec = this.recommendations[idx];
		},
		mapOdd(odd, recommendation) {
			odd.parent_match_id = recommendation.parent_match_id;
			odd.sport_id = recommendation.sport_id;
			return odd;
		},
		handleAddRecommendation(bet) {
			let vm = this;

			// add recommendations to analytics
			this.analyticsTrack("general", "recommendations", {
				id: bet.parent_match_id,
				home_team: bet.home_team,
				away_team: bet.away_team,
				market: bet.market,
				odd_key: bet.odd.odd_key,
				odd_value: bet.odd.odd_value,
			});

			// save as added for later placebet tracking
			vm.$store.dispatch(
				"recommendations/getAddedRecommendations",
				bet.parent_match_id
			);
		},
		handleRemoveRecommendation(bet) {
			let vm = this;
			vm.$store.commit(
				"recommendations/removeAddedRecommendations",
				bet.parent_match_id
			);
		},
		smoothScrollToBottom() {
			if (this.$store.getters.layout == "Mobile") {
				const element = document.getElementsByClassName("adjasted");

				if (element) {
					window.scrollTo(
						0,
						document.body.scrollHeight || document.documentElement.scrollHeight
					);
				}
			}
		},
		fetchRecommendations() {
			let vm = this;

			let matchIds = [];
			vm.bets.forEach(function (value) {
				matchIds.push(value.parent_match_id);
			});

			let params = {
				event_ids: matchIds.join(),
			};

			return vm.$store.dispatch("recommendations/getRecommendations", params);
		},
		hideShowRecommendations() {
			let vm = this;

			vm.$notifications.add({
				message: this.$t("betslip.you-have-opted-out-successfully"),
				title: this.$t("betslip.bet-recommendations"),
				type: "info",
				duration: 5000,
			});
			vm.$store.commit("settings/activateCard");

			vm.closeBottomSheet();
		},
		reset() {
			let vm = this;

			vm.closeBottomSheet();
			vm.$emit("reset");
		},
		showBottomSheet() {
			let vm = this;

			vm.canShowBottomSheet = true;
			vm.$nextTick(() => {
				vm.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			let vm = this;

			vm.$refs.bottomSheet.setState("close");
			vm.$nextTick(() => {
				vm.canShowBottomSheet = false;
			});
		},
		// humanTime(dateTime, minsDiff) {

		// 	if (dateTime !== null){

		// 		let theDateTime = null;

		// 		var now = this.$moment();
		// 		let current =  this.$moment(dateTime);

		// 		let timeDateDiff =  Math.max(0, current.diff(now, 'minutes'))

		// 		if(timeDateDiff < 1){

		// 			theDateTime =
		// 				"Started "+current.fromNow()

		// 		} else {

		// 			if(timeDateDiff > minsDiff){ //3 hours ahead

		// 				theDateTime = current.calendar(null, {
		// 					sameDay: "[Starts today at] LT",
		// 					nextDay: "[Starts tomorrow at] LT",
		// 					lastDay: "[Ended yesterday at] LT",
		// 					lastWeek: "Ended [on] Do of MMM YYYY [at] LT", //[last] on
		// 					nextWeek: "Starts [on] Do of MMM YYYY [at] LT",
		// 					sameElse: "Starts [on] Do of MMM YYYY [at] LT",
		// 				});

		// 			} else {

		// 				theDateTime =
		// 					"Starts "+current.fromNow()

		// 			}

		// 		}

		// 		return theDateTime;

		// 	} else {

		// 		return theDateTime;
		// 	}

		// },
	},
};
</script>

<style lang="scss">
.slider-recommendation {
	&__item {
		padding: 15px;
		border-radius: 8px;
		border: 1px solid var(--light-gray-border);
		background-color: var(--black-dark-20);

		&__close {
			svg {
				width: 12px;
				height: 12px;
			}
			@media (max-width: 320px) {
				svg {
					width: 9px;
					height: 9px;
				}
			}
		}
		&__market {
			&__container {
				display: flex;
				justify-content: space-between;
				align-items: center;
				flex-direction: row;
			}

			&__match {
				&__name {
					color: var(--active-state);
					font-size: var(--font-small);
					font-weight: var(--font-weight-medium);
					line-height: 1.2rem;
				}
			}

			&__time {
				color: var(--non-active-state);
				font-size: var(--font-smallest);
				font-weight: var(--font-weight-lighter);
			}
			&__odds {
				text-align: right;

				&--more {
					a {
						font-weight: var(--font-weight-normal);
						font-size: var(--font-smallest);
						color: var(--green);
						text-decoration: none;
						display: block;
					}
				}
				:last-child {
					margin-right: 0px !important;
				}
				&__recodds {
					display: flex;
					margin: 15px 0;

					.prebet-match {
						&__odd {
							padding: 8px 12px;
							margin-right: 3px;
							display: initial;
							line-height: 0rem;
							background-color: var(--line-11);

							&__odd-value {
								font-size: var(--font-smallest);
								line-height: normal;
							}
						}
					}
				}
			}
		}
	}
}
.bet-recommendations {
	background-color: var(--white);
	padding: 15px 10px;
	padding-bottom: 0;

	@media (max-width: 991px) {
		cursor: pointer;
	}
	&__header {
		p {
			text-align: left;
			font-size: var(--font-large);
			font-weight: var(--font-weight-lighter);
			color: var(--light-dark-blue);
			margin-bottom: 10px;
			margin-top: 0;
		}
	}
	&__footer {
		margin-top: 0px;
		text-align: center;
		p {
			margin-top: 5px;
		}
		span:first-child {
			margin-right: 10px;
		}
	}
	&__bottom_sheet {
		&__container {
			padding: 20px 30px;
			max-height: 60vh;
			overflow-y: auto;
			text-align: center;
			p {
				margin: 0;
				color: var(--light-dark-blue);
				font-weight: var(--font-weight-lighter);
			}
		}
		&__buttons {
			padding: 10px;
			&__apply {
				background: var(--green);
				font-style: normal;
				font-weight: var(--font-weight-medium);
				font-size: var(--font-medium);
				line-height: 20px;
				border: none;
				padding: 8px 0;
				text-align: center;
				color: var(--always-white);
				display: block;
				width: 100%;
				margin-bottom: 10px;
			}
			&__reset {
				background: none;
				font-style: normal;
				font-weight: var(--font-weight-medium);
				font-size: var(--font-medium);
				line-height: 20px;
				border: none;
				padding: 8px 0;
				text-align: center;
				color: var(--black);
				display: block;
				width: 100%;
			}
		}
	}
	.VueCarousel {
		&-dot-container {
			margin-top: 0px !important;

			&-dot {
				margin: 5px !important;
				&:focus {
					outline: 1px solid var(--green) !important;
				}
			}
		}

		&-navigation {
			&-button {
				top: 35% !important;
				color: var(--black) !important;
				background: none !important;
				border: none !important;
				padding: 0 5px !important;
				margin: 0 !important;
			}

			:focus {
				outline: 0 !important;
			}
		}

		.VueCarousel-inner {
			width: calc(100% - 50px);

			.VueCarousel-slide {
				margin-right: 5px;
				&:last-child {
					margin-right: 0;
				}
			}
		}
		@media (max-width: 991px) {
			.VueCarousel-pagination {
				display: none;
			}
		}
	}
}
</style>
